import { render } from "./ViewingOptionsPage.vue?vue&type=template&id=4be3a949&scoped=true"
import script from "./ViewingOptionsPage.vue?vue&type=script&lang=js"
export * from "./ViewingOptionsPage.vue?vue&type=script&lang=js"

import "./ViewingOptionsPage.vue?vue&type=style&index=0&id=4be3a949&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be3a949"]])

export default __exports__